import type { ReviewPhoto } from '@/shared/api/experience';
import { type ISliderImg } from '@experience/gallery-slider/dist/components/GallerySlider';
import { GalleryOriginType } from '@experience/gallery-slider/dist/components/GalleryTrigger';

export const reviewPhotoToGalleryImg = (photo: ReviewPhoto, index: number = 0, reviewId?: number): ISliderImg => {
  return {
    id: photo.id || `review-photo-${index}`,
    index,
    originId: reviewId || 0,
    originType: GalleryOriginType.REVIEW,
    alt: 'Фото из отзыва',
    srcPhoto: photo.medium || '',
    thumbPhoto: photo.thumbnail_s || photo.small || '',
  };
};
